/**
 * Created by pawel on 2017-02-07.
 */
(function ($) {

    pw.doc('Loader', '0.1.171216', ['$().addClass("loading")', 'segment:reload[data-segment]']);

    // Add Events by jQuery methods methods
    // "addClass", "toggleClass", "removeClass"
    $.map(["addClass", "removeClass"], function (method) {
        // Store the original handler
        var originalMethod = $.fn[method];

        $.fn[method] = function () {
            // Execute the original hanlder.
            var result = null;
            if (this[0]) {

                var oldClass = this[0].className;
                result = originalMethod.apply(this, arguments);
                var newClass = this[0].className;

                // trigger a custom event
                if ($.inArray('loading', arguments) >= 0) {
                    this.trigger('loader:' + method, [this, arguments]);
                }

            } else {
                result = originalMethod.apply(this, arguments);
            }
            return result;
        };
    });

    window.pwLoadreTemplate =
        '<div class="pw-lo-con">' +
        '<div class="h-fix"></div>' +
        '<div class="lo">' +
        ' <div class="lo-img"></div>' +
        ' <div class="lo-msg"></div>' +
        '</div>' +
        '</div>';

    window.pwLoadreImage =  $('#basePath').val() + '/img/loader-ring-alt.svg';

    var $loader = $(window.pwLoadreTemplate);

    $(document)
        .ready(function() {
            $.get( window.pwLoadreImage, function (data) {
                $loader.find('.lo-img').html(data);
            }, 'text');
        })
        // Call to addClass events
        .on("loader:addClass", function (e, ui, params) {

            var $e = ui, description = $e.attr('data-loader-description'), myLoader = null;

            if ($e.children('div.lo-con').length === 0) {
                // console.log('pw.loader add');
                myLoader = $loader.clone();
                $e.prepend(myLoader);
                if (description) {
                    $('<p class="lo-description">' + description + '</p>').appendTo($e.find('.lo-msg').eq(0));
                    // console.info('add loader description: ' + description);
                }
                // myLoader.css({height: $e.innerHeight()})
            } else {
                // console.log('pw.loader exists');
            }

        })
        // Call to removeClass events
        .on('loader:removeClass', function (e, ui, params) {
            var $e = ui;
            $e.find('> div.pw-lo-con').css({opacity: 0}).delay(1000).remove();
        });

})(jQuery);